import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { Validators } from '@angular/forms';
import { isThisQuarter } from 'date-fns';
import { LoginService } from 'src/app/services/login/login.service';
import { MedicPersoService } from 'src/app/services/medic-perso/medic-perso.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { IdCommunicationService } from 'src/app/services/node/id-communication.service';
import { PatientService } from 'src/app/services/patient/patient.service';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { SynapseAutocompleteResp, SynapseAutocompleteService, SynapseCardiacFailureEnum, SynapseEntiteTherapeutique, SynapseHepaticFailureEnum, SynapsePatientProfile, SynapseTypeEntiteTherapeutiqueEnum } from 'src/app/services/synapse-medicine/autocomplete.service';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { InputTemplate } from 'src/app/utils/interfaces/new/input-template.interface';
import { MedicPerso } from 'src/app/utils/interfaces/new/medic-perso.interface';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';
import { environment } from 'src/environments/environment';
import { textSpanContainsTextSpan } from 'typescript';
declare let Synapse: any;

@Component({
  selector: 'app-recherche-bdd-med',
  templateUrl: './recherche-bdd-med.fragment.html',
  styleUrls: [
    './recherche-bdd-med.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class RechercheBddMedFragment implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @Output() public closeEmitter = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeAddEditModal();
    }
  }
  patientId: string;

  resultatRechercheSynapse: SynapseAutocompleteResp[];
  myMedics: MedicPerso[];
  selectListOfMedic: SynapseEntiteTherapeutique[] = [];
  insHepatList: Referentiel[];
  insCardiacList: Referentiel[];
  preview: boolean;

  private jwtToken: string;

  profileWidget: any;
  posologyCheckerWidget: any;
  interactionWidget: any;
  groundsWidget: any;
  adverseEffectWidget: any;

  profile: SynapsePatientProfile = {};
  data: any = {};

  constructor(
    private _synapseAutocomp: SynapseAutocompleteService,
    private _medicPerso: MedicPersoService,
    private _modal: ModalService,
    private _view: ViewContainerRef,
    private _patient: PatientService,
    private _login: LoginService,
    private _ref: ReferentielService,
    private _send: IdCommunicationService
  ) { }

  async ngOnInit(): Promise<void> {
    this.myMedics = (await this._medicPerso.find()).objects;
    this.insHepatList = await this._ref.findRefListTable(ReferentielEnum.insHepat);
    this.insCardiacList = await this._ref.findRefListTable(ReferentielEnum.insCard);

    this.data = {
      entities: [],
      profile: this.profile
    };

    this.jwtToken = this._login.getCurrentProfil().licenceBdd;

    if (this.selectListOfMedic && this.selectListOfMedic.length > 0) {
      for (let medic of this.selectListOfMedic) {
        this.data.entities.push(medic);
      }
    }
    this.refreshWidgets();
  }

  // createSynapseWidgets() {
  //   const context = this;
  //   if (this.jwtToken) {
  //     this.profileWidget = new Synapse.PatientProfileWidget();
  //     this.posologyCheckerWidget = new Synapse.PosologyCheckerWidget();
  //     this.interactionWidget = new Synapse.InteractionWidget();
  //     this.groundsWidget = new Synapse.GroundsWidget();
  //     this.adverseEffectWidget = new Synapse.AdverseEffectWidget();

  //     this.profileWidget.setToken(this.jwtToken);
  //     this.posologyCheckerWidget.setToken(this.jwtToken);
  //     this.interactionWidget.setToken(this.jwtToken);
  //     this.groundsWidget.setToken(this.jwtToken);
  //     this.adverseEffectWidget.setToken(this.jwtToken);

  //     this.profileWidget.setCallback("onProfileUpdate", function (err, data) {
  //       context.onProfileUpdateSynapseWidget(err, data, context);
  //     });

  //     this.posologyCheckerWidget.setCallback("onPosologiesUpdate", function (err, data) {
  //       context.onPosologiesUpdateSynapseWidget(err, data, context);
  //     });

  //     this.posologyCheckerWidget.setCallback("onCommentsUpdate", function (err, data) {
  //       context.onCommentsUpdateSynapseWidget(err, data, context);
  //     });

  //     this.posologyCheckerWidget.setCallback("onDeleteEntity", function (err, data) {
  //       context.onDeleteEntitySynapseWidget(err, data, context);
  //     });

  //     this.profileWidget.init(document.getElementById("synapseProfile"), this.data);
  //     this.posologyCheckerWidget.init(document.getElementById("synapsePosology"), this.data);
  //     this.interactionWidget.init(document.getElementById("synapseInteract"), this.data);
  //     this.groundsWidget.init(document.getElementById("synapseGrounds"), this.data);
  //     this.adverseEffectWidget.init(document.getElementById("synapseAdverses"), this.data);
  //   }
  // }

  // onProfileUpdateSynapseWidget(err: any, data: any, context: this) {
  //   context.data.profile = data.profile;
  //   context.refreshWidgets();
  //   context.saveProfile(data.profile as SynapsePatientProfile);
  // }

  // async saveProfile(profil: SynapsePatientProfile) {
  //   let isChange = false;
  //   let currentPatientInfo = await this._patient.findOnePatientInfos(this.patientId);
  //   if (profil.grounds && profil.grounds.hepaticFailure) {
  //     const libHepat = this.translateReverseHepatSynapseToHypermed(profil.grounds.hepaticFailure);
  //     const idInsHepat = this.insHepatList.find(x => x.libelle === libHepat).id;
  //     currentPatientInfo.idInsuffisanceHepatique = idInsHepat;
  //     isChange = true
  //   }
  //   if (profil.grounds && profil.grounds.cardiacFailure) {
  //     const libCard = this.translateReverseCardiacSynapseToHypermed(profil.grounds.cardiacFailure);
  //     const idInsCard = this.insCardiacList.find(x => x.libelle === libCard).id;
  //     currentPatientInfo.idInsuffisanceCardiaque = idInsCard;
  //     isChange = true
  //   }

  //   if (isChange) {
  //     this._patient.updatePatientInfos(this.patientId, currentPatientInfo);
  //   }
  // }

  onPosologiesUpdateSynapseWidget(err: any, data: any, context: this) {
    for (let medicEntity of context.selectListOfMedic) {
      const newPosologies = data.posologies[medicEntity.cis] as any[];
      if (newPosologies) {
        for (let synapseMedicPosologie of newPosologies) {
          if (medicEntity.posologies) {
            const existingPoso = medicEntity.posologies.find(x => x.id === synapseMedicPosologie.structuredPosology.id);
            if (existingPoso) {
              const indexToReplace = medicEntity.posologies.indexOf(existingPoso);
              if (indexToReplace > -1) {
                medicEntity.posologies[indexToReplace] = synapseMedicPosologie.structuredPosology;
              }
            } else {
              medicEntity.posologies.push(synapseMedicPosologie.structuredPosology);
            }
          } else {
            medicEntity.posologies = [];
            medicEntity.posologies.push(synapseMedicPosologie.structuredPosology);
          }
        }
      }
    }
  }

  onCommentsUpdateSynapseWidget(err: any, data: any, context: this) {
    for (let medicEntity of context.selectListOfMedic) {
      const comment = data.comments[medicEntity.cis];
      if (comment) {
        medicEntity.motif = comment;
      }
    }
  }

  onDeleteEntitySynapseWidget(err: any, data: any, context: this) {
    context.selectListOfMedic.splice(context.selectListOfMedic.findIndex(x => x.cis === data.cis), 1);
    context.data.entities.splice(context.data.entities.findIndex(x => x.cis === data.cis), 1);
    context.refreshWidgets();
  }

  refreshWidgets() {
    if (
      this.profileWidget &&
      this.posologyCheckerWidget &&
      this.interactionWidget &&
      this.groundsWidget &&
      this.adverseEffectWidget
    ) {
      this.profileWidget.update(this.data);
      this.posologyCheckerWidget.update(this.data);
      this.interactionWidget.update(this.data);
      this.groundsWidget.update(this.data);
      this.adverseEffectWidget.update(this.data);
    } else {
      // this.createSynapseWidgets();
    }
  }

  async onSearchMedicament(event: string) {
    if (event.length >= 2) {
      this.resultatRechercheSynapse = await this._synapseAutocomp.autocomplete({
        text: event,
        size: 10,
        type: SynapseTypeEntiteTherapeutiqueEnum.MARQUE_MEDICAMENT
      });
    }
  }

  isInSelectEntities(medic: SynapseAutocompleteResp) {
    return this.data.entities.find(x => x.cis === medic.entity.cis) ? true : false;
  }

  selectMedic(medic: SynapseAutocompleteResp) {
    if (this.isInSelectEntities(medic)) {
      this.data.entities.splice(this.data.entities.findIndex(x => x.cis === medic.entity.cis), 1);
      this.selectListOfMedic.splice(this.selectListOfMedic.findIndex(x => x.cis === medic.entity.cis), 1);
    } else {
      medic.entity.posologies = [];
      this.data.entities.push(medic.entity);
      this.selectListOfMedic.push(medic.entity as SynapseEntiteTherapeutique);
    }
    this.refreshWidgets();
  }

  isFavoriteMedic(medic: SynapseAutocompleteResp): boolean {
    return this.myMedics.find(x => x.idProduit === medic.entity.cis) ? true : false;
  }

  async toggleFavMedic(medic: SynapseAutocompleteResp) {
    if (this.isFavoriteMedic(medic)) {
      const medicToUnfav = this.myMedics.find(x => x.idProduit === medic.entity.cis);
      if (medicToUnfav) {
        await this._medicPerso.delete(medicToUnfav.id);
      }
    } else {
      const newMedicPerso: MedicPerso = {
        idProduit: medic.entity.cis,
        libelle: medic.entity.label
      }
      await this._medicPerso.create(newMedicPerso);
    }
    await this.refreshMyMeds();
  }

  async refreshMyMeds() {
    this.myMedics = (await this._medicPerso.find()).objects;
  }

  public closeAddEditModal(object?: any): void {
    if (object) {
      this.closeEmitter.emit(object);
    } else {
      this.closeEmitter.emit(null);
    }
  }

  public stopPropagation(event): void {
    event.stopPropagation();
  }

  insertionOrdonnance() {
    if (this.selectListOfMedic.length > 0) {
      const confirmModal = this._modal.openModalConfirmation(this._view, "Confirmation de posologie", "Avez-vous vérifié votre prescription à l'aide des modules de vérification d'interactions médicamenteuses, des terrains cliniques et des effets secondaires ?");
      const sub = this._modal.closeEmitter.subscribe(res => {
        if (res) {
          this.closeAddEditModal(this.selectListOfMedic);
          sub.unsubscribe();
        } else {
          sub.unsubscribe();
        }
      });
    } else {
      this.closeAddEditModal();
    }
  }

  public translateHepatSynapse(key: string): SynapseHepaticFailureEnum {
    switch (key) {
      case "Non":
        return SynapseHepaticFailureEnum.NONE;
      case "Légère":
        return SynapseHepaticFailureEnum.LIGHT;
      case "Modérée":
        return SynapseHepaticFailureEnum.MODERATE;
      case "Sévère":
        return SynapseHepaticFailureEnum.HEAVY;
      default:
        return SynapseHepaticFailureEnum.NONE;
    }
  }

  public translateCardiacSynapse(key: string): SynapseCardiacFailureEnum {
    switch (key) {
      case "Non":
        return SynapseCardiacFailureEnum.NONE;
      case "Légère":
        return SynapseCardiacFailureEnum.LIGHT;
      case "Modérée":
        return SynapseCardiacFailureEnum.MODERATE;
      case "Sévère":
        return SynapseCardiacFailureEnum.HEAVY;
      default:
        return SynapseCardiacFailureEnum.NONE;
    }
  }

  public translateReverseHepatSynapseToHypermed(key: string): string {
    switch (key) {
      case SynapseHepaticFailureEnum.NONE:
        return "Non";
      case SynapseHepaticFailureEnum.LIGHT:
        return "Légère";
      case SynapseHepaticFailureEnum.MODERATE:
        return "Modérée";
      case SynapseHepaticFailureEnum.HEAVY:
        return "Sévère";
      default:
        return "Non";
    }
  }

  public translateReverseCardiacSynapseToHypermed(key: string): string {
    switch (key) {
      case SynapseCardiacFailureEnum.NONE:
        return "Non";
      case SynapseCardiacFailureEnum.LIGHT:
        return "Légère";
      case SynapseCardiacFailureEnum.MODERATE:
        return "Modérée";
      case SynapseCardiacFailureEnum.HEAVY:
        return "Sévère";
      default:
        return "Non";
    }
  }

}
